import axios from '../../axiosInstance';
import requests from '../../requests';
import { diagramActionTypes } from './diagram.types';

export const changeTheme = (theme) => ({
    type: diagramActionTypes.CHANGE_THEME,
    payload: { theme },
});
export const changeCursor = () => ({
    type: diagramActionTypes.CHANGE_CURSOR,
});

// =1==HISTORY=================================
export const historyUndo = (data) => ({
    type: diagramActionTypes.HISTORY_UNDO,
    payload: {
        ...data,
    },
});
export const historyRedo = (data) => ({
    type: diagramActionTypes.HISTORY_REDO,
    payload: {
        ...data,
    },
});
// --------------------------------------------------------------

export const updateFocusedGroup = (elementsIds, areasIds) => ({
    type: diagramActionTypes.UPDATE_FOCUSED_GROUP,
    payload: { elementsIds, areasIds },
});
export const updateFocusedElements = (payload) => ({
    type: diagramActionTypes.UPDATE_FOCUSED_ELEMENTS,
    payload,
});
export const updateFocusedLine = (payload) => ({
    type: diagramActionTypes.UPDATE_FOCUSED_LINE,
    payload,
});
export const updateFocusedInsideElement = (
    tableId,
    columnId,
    columnIndex,
    insideElementType
) => ({
    type: diagramActionTypes.UPDATE_FOCUSED_INSIDE_ELEMENT,
    payload: { tableId, columnId, columnIndex, insideElementType },
});

export const updateFocusedArea = (payload) => ({
    type: diagramActionTypes.UPDATE_FOCUSED_AREA,
    payload,
});

export const updateElementsPositions = (updatedElements, updatedLines) => ({
    type: diagramActionTypes.UPDATE_ELEMENTS_POSITIONS,
    payload: {
        updatedElements,
        updatedLines,
    },
});

export const updateAreasPositions = (updatedAreas) => ({
    type: diagramActionTypes.UPDATE_AREAS_POSITIONS,
    payload: {
        updatedAreas,
    },
});

export const updateLiveElementsPositions = (tableName) => ({
    type: diagramActionTypes.UPDATE_LIVE_ELEMENTS_POSITIONS,
    payload: tableName,
});

export const addNewElement = (element) => ({
    type: diagramActionTypes.ADD_NEW_ELEMENT,
    payload: element,
});
export const addNewLine = (line) => ({
    type: diagramActionTypes.ADD_NEW_LINE,
    payload: line,
});

export const addNewArea = (area) => ({
    type: diagramActionTypes.ADD_NEW_AREA,
    payload: area,
});
export const setNewAreaIdForElement = (elementId, areaId) => ({
    type: diagramActionTypes.SET_NEW_AREA_ID_FOR_ELEMENT,
    payload: {
        elementId,
        areaId,
    },
});
export const addNewAreaForFocusedElements = () => ({
    type: diagramActionTypes.ADD_NEW_AREA_FOR_FOCUSED_ELEMENTS,
});

export const addNewPenSegment = (penSegment) => ({
    type: diagramActionTypes.ADD_NEW_PEN_SEGMENT,
    payload: penSegment,
});

// 1. CONTROLS LEFT | NEW TABLE CLICK
export const enableBtnNewTableClick = () => ({
    type: diagramActionTypes.ENABLE_BTN_NEW_TABLE_CLICK,
});
export const disableBtnNewTableClick = () => ({
    type: diagramActionTypes.DISABLE_BTN_NEW_TABLE_CLICK,
});

// 2. CONTROLS LEFT | NEW TABLE GRAB
export const enableBtnNewTableGrab = () => ({
    type: diagramActionTypes.ENABLE_BTN_NEW_TABLE_GRAB,
});
export const disableBtnNewTableGrab = () => ({
    type: diagramActionTypes.DISABLE_BTN_NEW_TABLE_GRAB,
});

// 3. CONTROLS LEFT | NEW NOTE CLICK
export const enableBtnNewNoteClick = () => ({
    type: diagramActionTypes.ENABLE_BTN_NEW_NOTE_CLICK,
});
export const disableBtnNewNoteClick = () => ({
    type: diagramActionTypes.DISABLE_BTN_NEW_NOTE_CLICK,
});

// 4. CONTROLS LEFT | NEW NOTE GRAB
export const enableBtnNewNoteGrab = () => ({
    type: diagramActionTypes.ENABLE_BTN_NEW_NOTE_GRAB,
});
export const disableBtnNewNoteGrab = () => ({
    type: diagramActionTypes.DISABLE_BTN_NEW_NOTE_GRAB,
});

// 5. CONTROLS LEFT | NEW LINE
export const toggleBtnNewLine = () => ({
    type: diagramActionTypes.TOGGLE_BTN_NEW_LINE,
});

// 5. CONTROLS LEFT | NEW AREA
export const toggleBtnNewArea = (isKeyClick = false) => ({
    type: diagramActionTypes.TOGGLE_BTN_NEW_AREA,
    payload: {
        isKeyClick,
    },
});
export const disableBtnNewArea = () => ({
    type: diagramActionTypes.DISABLE_BTN_NEW_AREA,
});


// 5. CONTROLS LEFT | PEN
export const toggleBtnPen = () => ({
    type: diagramActionTypes.TOGGLE_BTN_PEN,
});

// 6. CONTROLS TOP | EXPORT
export const toggleBtnSettings = () => ({
    type: diagramActionTypes.TOGGLE_BTN_SETTINGS,
});

export const toggleBtnModalShortcuts = () => ({
    type: diagramActionTypes.TOGGLE_BTN_MODAL_SHORTCUTS,
});


// 6. CONTROLS TOP | PROFILE
export const toggleBtnProfile = () => ({
    type: diagramActionTypes.TOGGLE_BTN_PROFILE,
});



// 6. CONTROLS TOP | EXPORT
export const toggleBtnExport = () => ({
    type: diagramActionTypes.TOGGLE_BTN_EXPORT,
});
// 6. CONTROLS TOP | EXPORT
export const disableBtnExport = () => ({
    type: diagramActionTypes.DISABLE_BTN_EXPORT,
});

// 6. CONTROLS TOP | EXPORT IMAGE
export const toggleBtnExportImage = () => ({
    type: diagramActionTypes.TOGGLE_BTN_EXPORT_IMAGE,
});
// 6. CONTROLS TOP | EXPORT IMAGE
export const disableBtnExportImage = () => ({
    type: diagramActionTypes.DISABLE_BTN_EXPORT_IMAGE,
});

// 6. CONTROLS TOP | EXPORT CODE
export const toggleBtnExportCode = () => ({
    type: diagramActionTypes.TOGGLE_BTN_EXPORT_CODE,
});
// 6. CONTROLS TOP | EXPORT CODE
export const disableBtnExportCode = () => ({
    type: diagramActionTypes.DISABLE_BTN_EXPORT_CODE,
});

// 6. CONTROLS TOP | SQL SYNTAX
export const toggleBtnSqlSyntax = () => ({
    type: diagramActionTypes.TOGGLE_BTN_SQL_SYNTAX,
});
// 8. SQL SYNTAX
export const setSqlSyntax = (value) => ({
    type: diagramActionTypes.SET_SQL_SYNTAX,
    payload: {
        sqlSyntax: value,
    },
});

// 6. CONTROLS TOP | VIEW MODES
export const toggleBtnViewModes = () => ({
    type: diagramActionTypes.TOGGLE_BTN_VIEW_MODES,
});
// 6. CONTROLS TOP | VIEW MODES
export const disableBtnViewModes = () => ({
    type: diagramActionTypes.DISABLE_BTN_VIEW_MODES,
});

// 7. CONTROLS TOP | SEARCH
export const toggleBtnSearch = () => ({
    type: diagramActionTypes.TOGGLE_BTN_SEARCH,
});
// 8. CONTROLS TOP | LEFT PANEL
export const toggleBtnLeftPanel = () => ({
    type: diagramActionTypes.TOGGLE_BTN_LEFT_PANEL,
});
// 8. CONTROLS TOP | EDIT NAME
export const toggleBtnEditName = () => ({
    type: diagramActionTypes.TOGGLE_BTN_EDIT_NAME,
});

export const disableBtnPopupNews = () => ({
    type: diagramActionTypes.DISABLE_BTN_POPUP_NEWS,
});

// 8. CONTROLS BOTTOM | MINIMAP
export const toggleBtnMinimap = () => ({
    type: diagramActionTypes.TOGGLE_BTN_MINIMAP,
});

// 8. CONTROLS BOTTOM | INFORMATION & RESOURCES
export const toggleBtnInfoResources = () => ({
    type: diagramActionTypes.TOGGLE_BTN_INFO_RESOURCES,
});

// 8. CONTROLS TOP | RED GREEN VIEW
export const toggleBtnRedGreenView = () => ({
    type: diagramActionTypes.TOGGLE_BTN_RED_GREEN_VIEW,
});

// 8. VIEW MODE
export const setElementsViewMode = (value) => ({
    type: diagramActionTypes.SET_ELEMENTS_VIEW_MODE,
    payload: {
        viewMode: value,
    },
});

// 8. PEN MENU | COLOR
export const setNewPenColor = (value) => ({
    type: diagramActionTypes.SET_COLOR_NEW_PEN,
    payload: {
        color: value,
    },
});

// 8. PEN MENU | WIDTH
export const setNewPenWidth = (value) => ({
    type: diagramActionTypes.SET_WIDTH_NEW_PEN,
    payload: {
        width: value,
    },
});

// 8. PEN MENU | CLEAR
export const clearNewPen = () => ({
    type: diagramActionTypes.CLEAR_NEW_PEN,
});

// ------------- Context Menu

export const deleteFocusedArea = () => ({
    type: diagramActionTypes.DELETE_FOCUSED_AREA,
});

export const duplicateFocusedArea = () => ({
    type: diagramActionTypes.DUPLICATE_FOCUSED_AREA,
});

export const deleteElements = (elementsIds) => ({
    type: diagramActionTypes.DELETE_ELEMENTS_BY_IDS,
    payload: elementsIds,
});

export const duplicateElements = (elementsIds) => ({
    type: diagramActionTypes.DUPLICATE_ELEMENTS_BY_IDS,
    payload: elementsIds,
});

export const duplicateColumn = (tableId, columnId) => ({
    type: diagramActionTypes.DUPLICATE_COLUMN,
    payload: { tableId, columnId },
});


export const duplicateFocusedGroup = () => ({
    type: diagramActionTypes.DUPLICATE_FOCUSED_GROUP,
});

export const deleteFocusedGroup = () => ({
    type: diagramActionTypes.DELETE_FOCUSED_GROUP,
});


export const autoResizeElements = (elementsIds) => ({
    type: diagramActionTypes.AUTO_RESIZE_ELEMENTS_BY_IDS,
    payload: elementsIds,
});

export const updateScalePlus = () => ({
    type: diagramActionTypes.UPDATE_SCALE_PLUS,
});
export const updateScaleMinus = () => ({
    type: diagramActionTypes.UPDATE_SCALE_MINUS,
});
export const resetScale = () => ({
    type: diagramActionTypes.RESET_SCALE,
});

export const updateScale = (scale, x, y) => ({
    type: diagramActionTypes.UPDATE_SCALE,
    payload: { scale, x, y },
});
export const updateOriginXY = (x, y) => ({
    type: diagramActionTypes.UPDATE_ORIGIN_XY,
    payload: { x, y },
});
export const updateScaleToFit = () => ({
    type: diagramActionTypes.UPDATE_SCALE_TO_FIT,
});

export const setElementsBorder = (border) => ({
    type: diagramActionTypes.SET_ELEMENTS_BORDER,
    payload: {
        border,
    },
});
export const setAreaBorder = (border) => ({
    type: diagramActionTypes.SET_AREA_BORDER,
    payload: {
        border,
    },
});

export const setElementsColor = (color) => ({
    type: diagramActionTypes.SET_ELEMENTS_COLOR,
    payload: {
        color,
    },
});
export const setLineColor = (lineId, color) => ({
    type: diagramActionTypes.SET_LINE_COLOR,
    payload: {
        lineId,
        color,
    },
});

export const setAreaColor = (color) => ({
    type: diagramActionTypes.SET_AREA_COLOR,
    payload: {
        color,
    },
});

export const setColumnKey = (tableId, columnId, keyType) => ({
    type: diagramActionTypes.SET_COLUMN_KEY,
    payload: {
        tableId,
        columnId,
        keyType,
    },
});
export const setColumnNN = (tableId, columnId) => ({
    type: diagramActionTypes.SET_COLUMN_NOT_NULL,
    payload: {
        tableId,
        columnId,
    },
});
export const setColumnAutoIncrement = (tableId, columnId) => ({
    type: diagramActionTypes.SET_COLUMN_AUTO_INCREMENT,
    payload: {
        tableId,
        columnId,
    },
});
export const setColumnEnum = (tableId, columnId, values) => ({
    type: diagramActionTypes.SET_COLUMN_ENUM,
    payload: {
        tableId,
        columnId,
        values,
    },
});
export const setColumnDefaultValue = (tableId, columnId, value) => ({
    type: diagramActionTypes.SET_COLUMN_DEFAULT_VALUE,
    payload: {
        tableId,
        columnId,
        value,
    },
});
export const setColumnDescription = (tableId, columnId, value) => ({
    type: diagramActionTypes.SET_COLUMN_DESCRIPTION,
    payload: {
        tableId,
        columnId,
        value,
    },
});

export const setColumnGeneratedValue = (tableId, columnId, value) => ({
    type: diagramActionTypes.SET_COLUMN_GENERATED_VALUE,
    payload: {
        tableId,
        columnId,
        value,
    },
});

export const setColumnCheckValue = (tableId, columnId, value) => ({
    type: diagramActionTypes.SET_COLUMN_CHECK_VALUE,
    payload: {
        tableId,
        columnId,
        value,
    },
});


export const setElementDescription = (elementId, value) => ({
    type: diagramActionTypes.SET_ELEMENT_DESCRIPTION,
    payload: {
        elementId,
        value,
    },
});
export const setAreaDescription = (areaId, value) => ({
    type: diagramActionTypes.SET_AREA_DESCRIPTION,
    payload: {
        areaId,
        value,
    },
});
export const setLineDescription = (lineId, value) => ({
    type: diagramActionTypes.SET_LINE_DESCRIPTION,
    payload: {
        lineId,
        value,
    },
});



export const setColumnIndex = (tableId, columnId, indexType) => ({
    type: diagramActionTypes.SET_COLUMN_INDEX,
    payload: {
        tableId,
        columnId,
        indexType,
    },
});

export const deleteColumn = (tableId, columnId) => ({
    type: diagramActionTypes.DELETE_COLUMN,
    payload: {
        tableId,
        columnId,
    },
});

export const moveColumnAbove = (tableId, columnId) => ({
    type: diagramActionTypes.MOVE_COLUMN_ABOVE,
    payload: {
        tableId,
        columnId,
    },
});
export const moveColumnBelow = (tableId, columnId) => ({
    type: diagramActionTypes.MOVE_COLUMN_BELOW,
    payload: {
        tableId,
        columnId,
    },
});

export const addNewColumnAbove = (tableId, columnId) => ({
    type: diagramActionTypes.ADD_NEW_COLUMN_ABOVE,
    payload: {
        tableId,
        columnId,
    },
});
export const addNewColumnBelow = (
    tableId,
    columnId,
    isMoveToNextInsideElement = false
) => ({
    type: diagramActionTypes.ADD_NEW_COLUMN_BELOW,
    payload: {
        tableId,
        columnId,
        isMoveToNextInsideElement,
    },
});

export const addNewFirstColumn = (
    tableId,
    isMoveToNextInsideElement = false
) => ({
    type: diagramActionTypes.ADD_NEW_FIRST_COLUMN,
    payload: {
        tableId,
        isMoveToNextInsideElement,
    },
});

export const addNewColumnInTheEnd = (tableId) => ({
    type: diagramActionTypes.ADD_NEW_COLUMN_IN_THE_END,
    payload: {
        tableId,
    },
});
export const addNewColumnInTheStart = (tableId) => ({
    type: diagramActionTypes.ADD_NEW_COLUMN_IN_THE_START,
    payload: {
        tableId,
    },
});

export const showContextMenu = () => ({
    type: diagramActionTypes.SHOW_CONTEXT_MENU,
});

export const hideContextMenu = () => ({
    type: diagramActionTypes.HIDE_CONTEXT_MENU,
});

export const toggleVisibilityContextMenu = () => ({
    type: diagramActionTypes.TOGGLE_VISIBILITY_CONTEXT_MENU,
});

export const deleteLine = () => ({
    type: diagramActionTypes.DELETE_LINE,
});

export const setLineConnectorsReversed = (lineId) => ({
    type: diagramActionTypes.SET_LINE_CONNECTORS_REVERSED,
    payload: {
        lineId,
    },
});

export const setLineConnector = (lineId, direction, relationType) => ({
    type: diagramActionTypes.SET_LINE_CONNECTOR,
    payload: {
        lineId,
        direction,
        relationType,
    },
});

export const setLineSolidType = (lineId, solidType) => ({
    type: diagramActionTypes.SET_LINE_SOLID_TYPE,
    payload: {
        lineId,
        solidType,
    },
});

export const setLineOnTrigger = (lineId, triggerType, value) => ({
    type: diagramActionTypes.SET_LINE_ON_TRIGGER,
    payload: {
        lineId,
        triggerType,
        value,
    },
});

export const updateTableColumnName = (tableId, columnId, value, newWidth) => ({
    type: diagramActionTypes.UPDATE_TABLE_COLUMN_NAME,
    payload: { tableId, columnId, value, newWidth },
});
export const updateTableColumnType = (tableId, columnId, value, newWidth) => ({
    type: diagramActionTypes.UPDATE_TABLE_COLUMN_TYPE,
    payload: { tableId, columnId, value, newWidth },
});
export const updateTableHeaderName = (tableId, value) => ({
    type: diagramActionTypes.UPDATE_TABLE_HEADER_NAME,
    payload: { tableId, value },
});

export const focusOnColumnBelow = (tableId, columnId) => ({
    type: diagramActionTypes.FOCUS_ON_COLUMN_BELOW,
    payload: { tableId, columnId },
});
export const focusOnColumnAbove = (tableId, columnId) => ({
    type: diagramActionTypes.FOCUS_ON_COLUMN_ABOVE,
    payload: { tableId, columnId },
});

export const focusOnFirstColumn = (tableId) => ({
    type: diagramActionTypes.FOCUS_ON_FIRST_COLUMN,
    payload: { tableId },
});

export const preloadState = (payload) => ({
    type: diagramActionTypes.PRELOAD_STATE,
    payload,
});

export const setNoteAlignment = (elementId, alignmentValue) => ({
    type: diagramActionTypes.SET_NOTE_ALIGNMENT,
    payload: { elementId, alignmentValue },
});

export const setNoteFontMonospace = (elementId) => ({
    type: diagramActionTypes.SET_NOTE_FONT_MONOSPACE,
    payload: { elementId },
});

export const setNoteFontStyle = (elementId, fontStyleType, value) => ({
    type: diagramActionTypes.SET_NOTE_FONT_STYLE,
    payload: { elementId, fontStyleType, value },
});

export const clickEscape = () => ({
    type: diagramActionTypes.CLICK_ESCAPE,
});

export const setIsHistoryClicked = () => ({
    type: diagramActionTypes.SET_IS_HISTORY_CLICKED,
});

export const enableElementDescriptionEditing = () => ({
    type: diagramActionTypes.ENABLE_ELEMENT_DESCRIPTION_EDITING,
});

export const disableElementDescriptionEditing = () => ({
    type: diagramActionTypes.DISABLE_ELEMENT_DESCRIPTION_EDITING,
});

export const canvasStarted = () => ({
    type: diagramActionTypes.CANVAS_STARTED,
})
// export const moveToMain = () => ({
//     type: diagramActionTypes.MOVE_TO_MAIN,
// });













// FETCH DIAGRAM
// --------------------------------------------------------------
export const fetchDiagram = (diagramId) => ({
    type: diagramActionTypes.FETCH_DIAGRAM_REQUEST,
    payload: { diagramId },
})
export const fetchDiagramSuccess = (data) => ({
    type: diagramActionTypes.FETCH_DIAGRAM_SUCCESS,
    payload: { data },
})
export const fetchDiagramFailure = error => ({
    type: diagramActionTypes.FETCH_DIAGRAM_FAILURE,
    payload: error,
})



// PRICING PLAN LIMIT
// --------------------------------------------------------------
export const enableCanvasPricingPlanLimit = (type) => ({
    type: diagramActionTypes.ENABLE_CANVAS_MODAL_PRICING_PLAN_LIMIT,
    payload: { type },
});
export const disableCanvasPricingPlanLimit = (type) => ({
    type: diagramActionTypes.DISABLE_CANVAS_MODAL_PRICING_PLAN_LIMIT,
    payload: { type },
});
// export const togglePricingPlanUpgrade = () => ({
//     type: mainActionTypes.TOGGLE_MODAL_PRICING_PLAN_UPGRADE,
// });


// PRICING PLAN LIMIT MAX
// --------------------------------------------------------------
export const enableCanvasPricingPlanLimitMax = (type) => ({
    type: diagramActionTypes.ENABLE_CANVAS_MODAL_PRICING_PLAN_LIMIT_MAX,
    payload: { type },
});
export const disableCanvasPricingPlanLimitMax = (type) => ({
    type: diagramActionTypes.DISABLE_CANVAS_MODAL_PRICING_PLAN_LIMIT_MAX,
    payload: { type },
});

// // LOAD SAMPLE PROJECT DATA
// // --------------------------------------------------------------
// export const loadSampleProjectData = () => ({
//     type: diagramActionTypes.LOAD_SAMPLE_PROJECT_DATA,
// });

// MODAL DIAGRAM EXPORT SQL
// --------------------------------------------------------------
export const toggleModalDiagramExportSQL = (dbEngine) => ({
    type: diagramActionTypes.TOGGLE_MODAL_DIAGRAM_EXPORT_SQL,
    payload: { dbEngine },
});
export const disableModalDiagramExportSQL = () => ({
    type: diagramActionTypes.DISABLE_MODAL_DIAGRAM_EXPORT_SQL,
});

// FOCUS_ALL_ELEMENTS
// --------------------------------------------------------------
export const focusAllElements = () => ({
    type: diagramActionTypes.FOCUS_ALL_ELEMENTS,
});


// EXPORT IMAGE CLICK
// --------------------------------------------------------------
export const enableExportImageClick = () => ({
    type: diagramActionTypes.ENABLE_BTN_EXPORT_IMAGE_CLICK,
});
export const disableExportImageClick = () => ({
    type: diagramActionTypes.DISABLE_BTN_EXPORT_IMAGE_CLICK,
});
